import React from 'react'
import {sortBy} from 'lodash'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import { ButtonToolbar, Button } from 'react-bootstrap'

import AdminModal from './AdminModal'
import ConfirmModal from '../../../components/ConfirmModal'

import * as organizationService from '../../../services/organization-service'

export default class ExtraAdmins extends React.Component {

  constructor(props, context) {
    super(props, context)

    this.refresh = this.refresh.bind(this)
    this.deleteId = this.deleteId.bind(this)
    this.buttonFormatter = this.buttonFormatter.bind(this)
    this.performDelete = this.performDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)

    this.state = {
      id: this.props.id,
      admins: [],
      showConfirmDelete: false,
      idToDelete: undefined,
      kcuid: undefined,
    }
  }

  componentDidMount() {
    this.refresh()
  }

  refresh() {
    organizationService.getOrganization(this.state.id).then((data) => this.setState({admins: data.extraAdminDTOS}))
  }

  deleteId(row) {
    this.setState({showConfirmDelete: true, idToDelete: row.id, kcuid: row.kcUserId})
  
  }

  performDelete() {
    organizationService.deleteExtraAdmin(this.state.idToDelete, this.state.kcuid ).then(() => {
      this.setState({showConfirmDelete: false, idToDelete: undefined})
      this.refresh()
    })
  }

  cancelDelete() {
    this.setState({showConfirmDelete: false})
  }

  buttonFormatter(cell, row, id) {
    return (
      <div className='row-actions'>
        <AdminModal
          btnClassNames="edit-entry action-btn"
          title="Wijzigen medebeheerder"
          introText="Wilt u de gegevens van de medebeheerder wijzigen?"
          admin={row}
          reload={() => this.refresh()}
        />
        <Button className='delete-entry action-btn' onClick={
          () => this.deleteId(row)}>
        </Button>
      </div>
    )
  }

  render() {
    const {admins} = this.state

    admins.map((admin) => { 
      return admin.fullName = admin.lastName + ", " + admin.firstName + " " + (admin.prefix || "") 
    })
      
    function headerFormatter(column, colIndex, { sortElement }) {
      return (
        <span className="sortable-inner">
          <span className="text">{column.text}</span>
          {sortElement}
        </span>
      )
    }
  
    function contentFormatter(cell, row) {
      return (
        <span className="text">{cell}</span>
      )
    }

    const columns = [{
      dataField: 'fullName',
      text: 'Naam',
      sort: true,
      headerFormatter: headerFormatter,
      formatter: contentFormatter
    }, {
      dataField: 'email',
      text: 'E-mail',
      sort: true,
      headerFormatter: headerFormatter,
      formatter: contentFormatter
    }, {
      dataField: 'button',
      text: ' ',
      formatter: this.buttonFormatter
    }]
  
    const paginationOptions = paginationFactory({
      paginationSize: 5,
      hideSizePerPage: true,
      alwaysShowAllBtns: true
    })

    return (
      <div>
        <div className="user-table">
          {admins && <BootstrapTable
            keyField='id'
            data={sortBy(admins, "lastName")}
            columns={columns}
            bordered={ false }
            striped
            hover
            condensed
            pagination={ paginationOptions } />}
        </div>
        <div className="table-actions">
          <ButtonToolbar>
            <AdminModal
              btnClassNames="btn-open"
              title="Toevoegen medebeheerder"
              text="+ Toevoegen"
              introText="Wilt u een medebeheerder toevoegen? Een medebeheerder krijgt volledig toegang tot de gegevens van uw BrandWijzer-account en kan zelf ook gegevens toevoegen of verwijderen.<br/><br/>Na toevoegen ontvangt de medebeheerder een automatische uitnodigingsmail met login."
              reload={() => this.refresh()}
            />
          </ButtonToolbar>
        </div>
        <ConfirmModal 
          title="Verwijderen medebeheerder"
          body={`Wilt u deze medebeheerder verwijderen? Hiermee vervalt de toegang tot BrandWijzer voor deze persoon.`}
          show={this.state.showConfirmDelete} 
          onHide={this.cancelDelete}
          onSubmit={this.performDelete}
          confirmbuttontext="Verwijderen" />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/Account/components/ExtraAdmins.js